import { Props_SnippetImageContent } from './ImageContent.props'
import { Legacy_CompileMarkdown } from '../../../../Shared/AttraxTs/React/ReactSnippetMDCompiler'

const SnippetImageContent = (props: Props_SnippetImageContent) => {
    const { snippet, heading, image, content, link, theme } = props

    const classHeadingVisibility: string = heading.visibility?.value ? `snippet-content-column__heading--${heading.visibility.value}` : ''
    const classSnippetLayout = `snippet-image-content--${snippet.layout?.value}`

    return (
    <section className={`snippet-image-content ${classSnippetLayout} ${theme.background.value === 'dark' ? 'snippet-image-content--dark' : ''}`}>
        <div className="snippet-image-content__container">
            <div className="snippet-image-content__container-image">
                <img
                    loading="lazy"
                    src={image.src?.value}
                    className="snippet-image-content__image"
                    height="360"
                    width="600"
                    alt={image.alt?.value ? image.alt.value : ''}
                />
            </div>
            <div className="snippet-image-content__container-content">
                <h2 className={`snippet-image-content__heading ${classHeadingVisibility}`}>{heading.content?.value}</h2>
                <div className="snippet-image-content__content">
                    { Legacy_CompileMarkdown(content.content?.value || '') }
                </div>
                { link.url?.value && link.content?.value && (
                    <a
                        className="snippet-image-content__link"
                        href={link.url.value}
                        target={link.openInNewTab?.value === 'true' ? '_blank' : '_self'}
                    >
                        {link.content?.value}
                    </a>
                )}
            </div>
        </div>
    </section>
    )
}

export default SnippetImageContent